import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import axios from 'axios';
import keys from './keys';
import config from '../../../../config';

const useGetWaveForm = ({ audioUrl, disabled } = {}) => {
  const { showId } = useParams();

  const query = useQuery({
    queryKey: keys(showId).waveform(audioUrl),
    queryFn: async () => {
      const res = await axios({
        url: `${config.waveformUrl}/waveform?url=${audioUrl}`,
        responseType: 'text',
      });
      return res.data;
    },
    enabled: Boolean(audioUrl) && !disabled,
  });

  return {
    waveForm: query.data,
    waveFormDataError: query.error,
    isWaveFormDataFetchError: query.isError,
    isWaveFormDataFetchSuccess: query.isSuccess,
    iswaveFormDataFetching: query.isFetching,
    isWaveFormDataLoading: query.isInitialLoading,
    ...query,
  };
};

useGetWaveForm.propTypes = {
  audioUrl: PropTypes.string,
  disabled: PropTypes.bool,
};

export default useGetWaveForm;
